import { useEffect } from 'react';

interface SEOMetaProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogImage?: string;
  ogType?: string;
  schema?: Record<string, unknown>;
}

export default function SEOMeta({
  title,
  description,
  keywords,
  canonicalUrl,
  ogImage,
  ogType = 'website',
  schema,
}: SEOMetaProps) {
  const fullTitle = `${title} - 凤楼信息`;
  const siteUrl = canonicalUrl || 'https://www.fenglou-info.com';

  useEffect(() => {
    document.title = fullTitle;
    const metaTags: Record<string, string> = {
      description,
      ...(keywords && { keywords }),
      'og:title': fullTitle,
      'og:description': description,
      'og:type': ogType,
      'og:url': siteUrl,
      ...(ogImage && { 'og:image': ogImage }),
      'og:site_name': '凤楼信息',
      'og:locale': 'zh_CN',
      'twitter:card': 'summary_large_image',
      'twitter:title': fullTitle,
      'twitter:description': description,
      ...(ogImage && { 'twitter:image': ogImage }),
    };

    const setMetaTag = (name: string, content: string) => {
      const attr = name.startsWith('og:') ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    Object.entries(metaTags).forEach(([name, content]) => {
      setMetaTag(name, content);
    });

    let canonicalEl = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonicalEl) {
      canonicalEl = document.createElement('link');
      canonicalEl.rel = 'canonical';
      document.head.appendChild(canonicalEl);
    }
    canonicalEl.href = siteUrl;

    let schemaEl: HTMLScriptElement | null = null;
    if (schema) {
      const existingSchema = document.querySelector('script[type="application/ld+json"]');
      if (existingSchema) {
        existingSchema.remove();
      }
      schemaEl = document.createElement('script');
      schemaEl.type = 'application/ld+json';
      schemaEl.textContent = JSON.stringify(schema);
      document.head.appendChild(schemaEl);
    }
  }, [fullTitle, description, keywords, siteUrl, ogImage, ogType, schema]);

  return null;
}